import { useTranslation } from 'react-i18next';
import { Text } from '@client/toolkit';

export function AgreementStatisticsHeader() {
  const { t: tGlobal, ready } = useTranslation('global');

  return (
    <div className="border-t border-border" style={{ backgroundColor: '#332F2C' }}>
      <div className="flex items-center px-2 py-2">
        <div className="px-3 py-1 min-w-[360px]">
          <Text
            as="div"
            className="font-medium text-white text-xs whitespace-nowrap"
            loading={!ready}
          >
            {tGlobal('entity.building')}
          </Text>
        </div>
        <div className="flex-1 flex items-center justify-end">
          <div className="flex items-center gap-4">
          <div className="px-3 py-1 text-left w-[120px]">
            <Text
              as="div"
              className="font-medium text-white text-xs whitespace-nowrap"
              loading={!ready}
            >
              {tGlobal('entity.activeTenant_plural')}
            </Text>
          </div>
          <div className="px-3 py-1 text-left w-[110px]">
            <Text
              as="div"
              className="font-medium text-white text-xs whitespace-nowrap"
              loading={!ready}
            >
              {tGlobal('entity.activeAgreement_plural')}
            </Text>
          </div>
          <div className="px-3 py-1 text-left w-[145px]">
            <Text
              as="div"
              className="font-medium text-white text-xs whitespace-nowrap"
              loading={!ready}
            >
              {tGlobal('agreement.rentedArea')}
            </Text>
          </div>
          <div className="px-3 py-1 text-left w-[120px]">
            <Text
              as="div"
              className="font-medium text-white text-xs whitespace-nowrap"
              loading={!ready}
            >
              {tGlobal('agreement.totalYearlyAmount')}
            </Text>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
}
